import { ChangeEvent, Dispatch, useEffect, useRef } from 'react';
import { log } from '../../../../utils';
import { useSnackbar } from 'notistack';
import {
  UseFormReset,
  UseFormGetValues,
  UseFormSetValue
} from 'react-hook-form';
import { checkResData } from '../../../../utils/common';
import {
  copySiteProcess,
  updateConstructionExpectedDates,
  getConstructionExpectedDates
} from '../../../../apicalls/process';
import { TCopySiteProcessForm } from '../../../../types/process';

export type Props = {
  setIsOpen: Dispatch<boolean>;
  isOpen: boolean;
  reset: UseFormReset<any>;
  getValues: UseFormGetValues<any>;
  setValue: UseFormSetValue<any>;
  afterSubmit: () => void;
  currentConstructId: number;
  setHasExpectedDays?: Dispatch<boolean>;
  setHasSiteProcess?: Dispatch<boolean>;
};

export const useHooks = (props: Props) => {
  const {
    setIsOpen,
    isOpen,
    reset,
    getValues,
    setValue,
    afterSubmit,
    currentConstructId,
    setHasExpectedDays,
    setHasSiteProcess
  } = props;

  // snackbar
  const { enqueueSnackbar } = useSnackbar();

  // radioボタンの設定
  const copyCategory = [
    { name: '大工程/小工程/タスク', value: '1' },
    { name: '大工程/小工程', value: '2' },
    { name: '大工程のみ', value: '3' }
  ];

  // 送信可能フラグ 多重送信対策
  const isSubmitable = useRef(false);

  const submit = async (form: TCopySiteProcessForm) => {
    if (!isSubmitable.current) return;

    isSubmitable.current = false;

    try {
      //工事の契約予定日, 竣工予定日を更新
      await updateConstructionExpectedDates(
        currentConstructId,
        form.start_date,
        form.end_date
      );

      const resData = await copySiteProcess(
        currentConstructId,
        form.construct_id.value,
        form.category
      );

      const data = await checkResData(resData, enqueueSnackbar);
      if (data) {
        setIsOpen(false);
        setHasExpectedDays?.(true);
        setHasSiteProcess?.(true);
        afterSubmit();
      } else {
        isSubmitable.current = true;
      }
    } catch (err) {
      enqueueSnackbar('予定日の更新または工程コピーに失敗しました', {
        variant: 'error'
      });
      console.log(err);
      isSubmitable.current = true;
    }
  };

  // コピー範囲変更のハンドラ
  const handleChangeOrderTypeRadio = (e: ChangeEvent<HTMLInputElement>) => {
    setValue('category', e.target.value);
  };

  // キャンセル時の処理
  const cancelSubmit = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    // 初期値セット
    reset({
      category: '1',
      construct_id: { value: 0, label: '--' }
    });
    if (isOpen) {
      // オープン時に送信可能にする
      isSubmitable.current = true;
    }
    getConstructionExpectedDates(currentConstructId)
      .then(res => {
        if (!res || typeof res !== 'object') return;

        setValue('start_date', res.expected_contract_date || null);
        setValue('end_date', res.expected_end_date || null);
      })
      .catch(err => {
        console.error('予定日の取得に失敗しました:', err);
      });
  }, [isOpen]);

  return {
    submit,
    cancelSubmit,
    handleChangeOrderTypeRadio,
    copyCategory
  };
};
